import React from 'react';
import enhance from './AgeRangeSelector.enhancer';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { RadioIcon, RadioFillIcon, grey, primary } from '../../../style';

class AgeRangeSelector extends React.Component {
  constructor() {
    super();

    const initialState = {
      campaignRows: [],
      loadComplete: false
    };

    this.state = {
      ...initialState
    };
  }

  render() {
    const { campaignRows, loadComplete } = this.state;
    const { classes, ageRangeChangeHandler, ageRange } = this.props;

    return (
      <RadioGroup
        aria-label="genderRadioGroup"
        name="genderSelector"
        className={classes.radioGroup}
        onChange={ageRangeChangeHandler}
        value={ageRange}
      >
        <FormControlLabel
          value="All"
          control={
            <Radio
              color="primary"
              icon={<RadioIcon htmlColor={'white'} />}
              checkedIcon={<RadioFillIcon htmlColor={'white'} />}
            />
          }
          label="All"
          labelPlacement="end"
        />
        <FormControlLabel
          value="13"
          control={
            <Radio
              color="primary"
              icon={<RadioIcon htmlColor={'white'} />}
              checkedIcon={<RadioFillIcon htmlColor={'white'} />}
            />
          }
          label="13-17"
          labelPlacement="end"
        />
        <FormControlLabel
          value="18"
          control={
            <Radio
              color="primary"
              icon={<RadioIcon htmlColor={'white'} />}
              checkedIcon={<RadioFillIcon htmlColor={'white'} />}
            />
          }
          label="18-24"
          labelPlacement="end"
        />
        <FormControlLabel
          value="25"
          control={
            <Radio
              color="primary"
              icon={<RadioIcon htmlColor={'white'} />}
              checkedIcon={<RadioFillIcon htmlColor={'white'} />}
            />
          }
          label="25-34"
          labelPlacement="end"
        />
        <FormControlLabel
          value="35"
          control={
            <Radio
              color="primary"
              icon={<RadioIcon htmlColor={'white'} />}
              checkedIcon={<RadioFillIcon htmlColor={'white'} />}
            />
          }
          label="35-44"
          labelPlacement="end"
        />
        <FormControlLabel
          value="45"
          control={
            <Radio
              color="primary"
              icon={<RadioIcon htmlColor={'white'} />}
              checkedIcon={<RadioFillIcon htmlColor={'white'} />}
            />
          }
          label="45-54"
          labelPlacement="end"
        />
        <FormControlLabel
          value="64"
          control={
            <Radio
              color="primary"
              icon={<RadioIcon htmlColor={'white'} />}
              checkedIcon={<RadioFillIcon htmlColor={'white'} />}
            />
          }
          label="55-64"
          labelPlacement="end"
        />
        <FormControlLabel
          value="65"
          control={
            <Radio
              color="primary"
              icon={<RadioIcon htmlColor={'white'} />}
              checkedIcon={<RadioFillIcon htmlColor={'white'} />}
            />
          }
          label="65+"
          labelPlacement="end"
        />
      </RadioGroup>
    );
  }
}

export default enhance(AgeRangeSelector);



// WEBPACK FOOTER //
// ./src/components/company/discover-influencers/AgeRangeSelector.js